module.exports = __webpack_public_path__ + "img/download-tip.e42ac44e.svg";